type Props = {
  title: string;
  description?: string;
};

const MyBizListEmpty = ({ title, description }: Props) => {
  return (
    <div className="wallet_empty">
      <div className="inner_wallet_empty inner_wallet_empty1">
        <div className="wrap_icon">
          <strong className="ico_wallet ico_exclam_60">알림</strong>
        </div>
        <strong className="tit_empty">{title}</strong>
        {description && <p className="desc_empty">{description}</p>}
      </div>
    </div>
  );
};

export default MyBizListEmpty;
